import React, { useEffect, useState } from "react"
import Main from '@modules/Home/Main';
import Brand from '@modules/Home/Brand';
import HotList from '@modules/Home/HotList';
import Direct from '@modules/Home/Direct';
import Download from '@modules/Home/Download';
import qrcode from '@images/qrcode-download-app.png';
import qrIcon from '@images/qrcodeicon.png';
import topIcon from '@images/top.png'
import './index.scss';
import SEO from './seo';
import { isBrowser, isMobile } from "@/lib/utils"

let menuItemOffsetHeight: any;
let headerHeight: any;
let mHotListTabWrapOffsetHeight: any;

const IndexPage = (props: any) => {
  const homeData = props?.pageContext?.homeData || {};
  const [isPC, setIsPC] = useState(isBrowser ? document.body.clientWidth >= 960 : true)

  const judgePC = () => {
    setIsPC(document.body.clientWidth >= 960)
  }

  React.useEffect(() => {
    getHeight()
    judgePC()
    window.addEventListener('resize', () => judgePC(), false)
    return window.removeEventListener('resize', () => judgePC(), false)
  }, [isPC])

  function getHeight() {
    window.scrollTo(0, 0)
    const header: HTMLElement | null = document.querySelector('#l-m-header-container')
    const menuItem: HTMLElement | null = document.querySelector('.menu-items')
    const tabWrap: HTMLElement | null = document.querySelector('.m-hot-list .tab-wrap')
    menuItemOffsetHeight = menuItem?.getBoundingClientRect().top
    mHotListTabWrapOffsetHeight = tabWrap?.getBoundingClientRect().top
    headerHeight = header?.offsetHeight
  }

  function handleTop() {
    const html: any = document.querySelector('html');
    html.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  useEffect(() => {
    if (isPC) return
    const tabWrap: HTMLElement | null = document.querySelector('.m-hot-list .tab-wrap')
    const menuItem: HTMLElement | null = document.querySelector('.menu-items')

    // 移动端滚动自动加载
    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset
      if (scrollTop + headerHeight >= menuItemOffsetHeight) {
        if (scrollTop + headerHeight >= mHotListTabWrapOffsetHeight) {
          // 热卖fixed
          tabWrap!.className = 'tab-wrap tab-wrap-fixed'
          menuItem!.className = 'menu-items'
        } else {
          // 品牌fixed
          menuItem!.className = 'menu-items menu-items-fixed'
          tabWrap!.className = 'tab-wrap'
        }
      } else {
        // all clear
        tabWrap!.className = 'tab-wrap'
        menuItem!.className = 'menu-items'
      }
    })

    return window.removeEventListener('scroll', () => { })
  }, [isPC])

  return (
    <div className='p-home'>
      <SEO
        title='别样_别样海外购官方网站_别样海外购 bieyangapp.com'
        description='“别样”（Beyond）是一个欧美时尚商品海外直购APP，是直接和欧美商户合作，搭建商户和中国海淘人群之间的桥梁。让用户不用翻墙，就可以在海外知名商家下单选购心仪的商品，并享受和当地完全同步的价格和优惠活动，让用户来一场全程包关税、无差价的全球购；无需转运，直接填写中国收货地址，就能让商品送货上门'
        keywords='别样，别样App,别样海外购'
      />
      <Main amount={homeData?.giftInfo?.amount || '688元'} />
      <Brand brands={homeData?.tabs || []} />
      <HotList hotList={homeData?.topSelling?.tabs || []} />
      <Direct />
      <div className='floating-download'>
        <Download qrcodeImg={qrcode} amount={homeData?.giftInfo?.amount || '688元'} />
        <div className='button-wrap'>
          <img src={qrIcon} className='qr-icon' />
          <img src={topIcon} onClick={handleTop} className='top-icon' />
        </div>
      </div>
    </div>
  )
}

export default IndexPage